import { render, staticRenderFns } from "./ErrorHeaderSection.vue?vue&type=template&id=40390961&scoped=true"
import script from "./ErrorHeaderSection.vue?vue&type=script&lang=ts"
export * from "./ErrorHeaderSection.vue?vue&type=script&lang=ts"
import style0 from "./ErrorHeaderSection.vue?vue&type=style&index=0&id=40390961&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40390961",
  null
  
)

export default component.exports